/**
 * YALA 8-point spacing scale (JS).
 * Prefer CSS var(--yds-space-*) in stylesheets.
 */
export const YALA_SPACING = {
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  8: 32,
  10: 40,
  12: 48,
};

export const YALA_SPACE_PX = {
  space1: "4px",
  space2: "8px",
  space3: "12px",
  space4: "16px",
  space5: "20px",
  space6: "24px",
  space8: "32px",
  space10: "40px",
  space12: "48px",
};
